import * as propTypes from 'prop-types';
import * as React from 'react';
import { Button } from '../../../components/Button/Button';
import { __ } from '../../../helpers/TranslationService';
import styled from '@emotion/styled';

const ButtonWrapper = styled.div`
    margin: 20px 15px;
`;
interface IProps {
    onClick: () => void;
    isRequestFormValid?: boolean;
    newsletterSubscription?: boolean;
    testSelectorName?: string;
    buttonText?: string;
    disabled?: boolean;
}

class SubmitButtonComponent extends React.Component<IProps, {}> {
    static contextTypes = {
        track: propTypes.func,
    };

    onClick = () => {
        if (this.props.disabled) return;

        this.props.onClick();
        if (this.context.track && this.props.isRequestFormValid) {
            this.context.track({
                category: 'mobile request form',
                action: 'request button',
                label: 'service',
            });
            if (this.props.newsletterSubscription) {
                this.context.track({
                    category: 'mobile request form',
                    action: 'newsletter signup',
                    label: 'true',
                });
            }
        }
    };

    render() {
        const buttonText =
            this.props.buttonText === undefined
                ? __('Anfrage senden', 'dreamlines')
                : this.props.buttonText;

        return (
            <ButtonWrapper>
                <Button
                    fullWidth
                    withArrow
                    testSelectorName={this.props.testSelectorName}
                    onClick={this.props.onClick}
                >
                    {buttonText}
                </Button>
            </ButtonWrapper>
        );
    }
}

export const SubmitButton = SubmitButtonComponent;
